// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SlidersOutlinedSvg from "@fishx/icons-svg/es/asn/SlidersOutlined";
import FishxIcon from '../components/FishxIcon';

var SlidersOutlined = function SlidersOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SlidersOutlinedSvg
  }));
};

SlidersOutlined.displayName = 'SlidersOutlined';
export default React.forwardRef(SlidersOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SlidersOutlined.js
// module id = 4152
// module chunks = 0